import "./tabsStyles.css";
import { Col, Row, Container } from "react-bootstrap";

export default function NowTab({ data }: any) {
  const convertTimeStamp = (unixTimestamp: number) => {
    let time = new Date(unixTimestamp * 1000).toLocaleTimeString("en-US");
    return time;
  };

  return (
    <div className="make-visible">
      <h2>Now</h2>
      <Container>
        <Row xs={2} md={4} className="clean-box">
          <Col>Sunrise : </Col>
          <Col>{convertTimeStamp(data.current.sunrise)}</Col>
          <Col>Sunset : </Col>
          <Col>{convertTimeStamp(data.current.sunset)}</Col>
        </Row>

        <Row xs={2} md={4} className="clean-box">
          <Col>Dew Point : </Col>
          <Col> {data.current.dew_point}°C </Col>
          <Col>Visibility : </Col>
          <Col> {data.current.visibility} Km </Col>
        </Row>
        <Row xs={2} md={4} className="clean-box">
          <Col>Wind : </Col>
          <Col> {data.current.wind_speed} m/sec </Col>
          <Col>Wind Direction : </Col>
          <Col> {data.current.wind_deg}° </Col>
        </Row>
        <Row xs={2} md={4} className="clean-box">
          <Col>UV Index : </Col>
          <Col> {data.current.uvi} out of 10 </Col>
          <Col>Humidity : </Col>
          <Col> {Math.round(data.current.humidity * 100)}% </Col>
        </Row>
        <Row xs={2} md={4} className="clean-box">
          <Col>Pressure : </Col>
          <Col> {data.current.pressure} mb </Col>
          <Col>Cloud Cover : </Col>
          <Col> {Math.round(data.current.clouds * 100)}% </Col>
        </Row>
      </Container>
    </div>
  );
}
